export const SPEED = 2;
export const STARTING_FRAME = 15;
export const ENDING_FRAME = 55;
